var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "needsValidation" },
    [
      _c("div", { staticClass: "filter-container" }, [
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "el-button",
              {
                staticClass: "mb-10 download-btn",
                attrs: { type: "info", size: "small", icon: "el-icon-plus" },
                on: { click: _vm.onClickCreateBtn },
              },
              [_vm._v(_vm._s(_vm.$t("payment_page.create_new_link")))]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "tableContainer",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.create_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.create_time) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.creator"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.operate_user_name)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.reference"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.reference_batch_no)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.submit_quantity"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.submit_quantity))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("data.total_amount"), align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("toThousandFilter")(scope.row.amount))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.validation"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.validate
                          ? _c(
                              "el-tag",
                              {
                                staticClass: "tag-custom",
                                attrs: { type: "danger" },
                              },
                              [_vm._v("Failed")]
                            )
                          : _c(
                              "el-tag",
                              {
                                staticClass: "tag-custom",
                                attrs: { type: "success" },
                              },
                              [_vm._v("Passed")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.submit"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function ",
                                "icon-class": "operation-submit",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickSubmitReviewBtn(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.delete"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function ",
                                "icon-class": "operation-delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDeleteBtn(
                                    scope.row.reference_batch_no
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          { attrs: { placement: "top" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("components.detail"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                              ]
                            ),
                            _c("svg-icon", {
                              attrs: {
                                "class-name": "icon-function",
                                "icon-class": "operation-detail",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClickDetailBtn(
                                    scope.row.reference_batch_no
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("ChooseCreatePaymentWayModal", {
        ref: "chooseCreatePaymentWayModal",
        on: { getAllReferenceInfo: _vm.getAllReferenceInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }